<template>
    <div>
        <div class="banner">
            <div>
                <h3>安全风险管理系统</h3>
                <p>场站数字化运营风险管控平台</p>
            </div>
        </div>
        <div class="commmon-padding fenxian2 content1" id="fenxian2">
            <div v-show="fenxian2_animation" :class="{ 'img-parent': true, 'fadeInLeft': fenxian2_animation }">
                <img class="img" :src="fenxian2" />
            </div>
            <div v-show="fenxian2_animation" :class="{ 'introduct': true, 'fadeInRight': fenxian2_animation }">
                <div class="commit-tit">
                    <h3>安全风险管理系统</h3>
                    <!-- <div class="small-text">DIGITAL MANAGEMENT PLATFORM</div> -->
                </div>
                <div class="text">
                    <!-- <h5>氢能产业链数字孪生平台</h5> -->
                    安全风险管理系统是针对氢能各种使用场景进行安全生产监控的综合管理系统针对各目标场景定制的设备台账、智慧派单、风险识别、大数据分析、安全档案等核心模块组成该套系统可有效帮助客户对全业务场景进行安全监控与防范。
                </div>
            </div>
        </div>
        <div class="strip">
            <div class="commmon-padding content2" id="content2">
                <ul v-show="content2_animation" :class="{ 'fadeInUp': content2_animation }">
                    <li data-name="name1" :class="{ active: activeName == 'name1' }" @mouseenter="mouseEnter"
                        @mouseleave="mouseOut">
                        <p>
                            <table>
                                <tr>
                                    <td><i>*</i></td>
                                    <td> 可提供多种在线、离线检测方式对氢气泄漏进行识别；</td>
                                </tr>
                            </table>
                        </p>
                        <p>
                            <table>
                                <tr>
                                    <td><i>*</i></td>
                                    <td> 可针对不同场景，为用户提供最佳的检测方式；</td>
                                </tr>
                            </table>
                        </p>
                    </li>
                    <li data-name="name2" :class="{ active: activeName == 'name2' }" @mouseenter="mouseEnter"
                        @mouseleave="mouseOut">
                        <p>
                            <table>
                                <tr>
                                    <td>*</td>
                                    <td>对于纳入系统监测的监测点具备全生命周期监测能力；</td>
                                </tr>
                            </table> 
                        </p>
                        <p>
                            <table>
                                <tr>
                                    <td><i>*</i></td>
                                    <td>有效对其变化趋势进行分析，总结经验，优化设备保养制度，预防风险；</td>
                                </tr>
                            </table>
                        </p>
                    </li>
                    <li data-name="name3" :class="{ active: activeName == 'name3' }" @mouseenter="mouseEnter"
                        @mouseleave="mouseOut">
                        <p>
                            <table>
                                <tr>
                                    <td><i>*</i></td>
                                    <td> 通过业务管理系统，可实现秒级响应速度、并进行一线安全员精准派单;</td>
                                </tr>
                            </table>
                        </p>
                        <p>
                            <table>
                                <tr>
                                    <td><i>*</i></td>
                                    <td>保证人工检测的准确及时，预防安全事故发生；</td>
                                </tr>
                            </table>
                        </p>
                    </li>
                    <li data-name="name4" :class="{ active: activeName == 'name4' }" @mouseenter="mouseEnter"
                        @mouseleave="mouseOut">
                        <p>
                            <table>
                                <tr>
                                    <td><i>*</i></td>
                                    <td>所有监测点均可溯源历史维护、检查状态，为事后监管、调查、分析提供精准数据支持；</td>
                                </tr>
                            </table>
                        </p>
                    </li>
                </ul>
                <div id="content22">
                    <div class="intr">
                        <table v-show="content22_animation" :class="{ 'fadeInDown': content22_animation }">
                            <tr>
                                <td><img :src="dui" alt=""></td>
                                <td>自主开发的安全风险智慧管理平台和各类传感设备的互联互通，对加氢站关键部位临氢密封件进行全方位、全时段、全生命周期的实时监控与管理。</td>
                            </tr>
                        </table>
                    </div>
                    <div class="intr">
                        <table v-show="content22_animation" :class="{ 'fadeInUp': content22_animation }">
                            <tr>
                                <td><img :src="dui" alt=""></td>
                                <td>利用泄漏点检测技术、AI图像识别技术打造安全风险管理系统提升场站安全系数，积累实际生产中的易泄漏点位、泄漏原因、密封件生命周期和损耗情况等数据进行分析，打造分级风险管理体系。
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

            </div>
        </div>
        <div class="commmon-padding content3">
            <div id="content3-title">
                <div v-show="workflow_title_animation" :class="{ 'introduct': true, 'fadeInUp': workflow_title_animation }">
                    <div class="commit-tit">
                        <h3>系统工作流程示意</h3>
                        <div class="small-text">System Workflow Diagram</div>
                    </div>
                    <div class="text">

                    </div>
                </div>
            </div>

            <div v-show="workflow_content_animation" :class="{ 'line': true, 'fadeInUp': workflow_title_animation }">
            </div>
            <div id="content3-content">
                <div v-show="workflow_content_animation" :class="{ 'content': true, }">
                   
                    <div class="flex-item" :class="{ 'fadeInLeft1': workflow_content_animation }">
                        <p>建档</p>
                        <img :src="require('@/assets/img/safe/t2.png')" alt="">
                        <p>对目标监测点位进行持续监测与记录</p>
                    </div>
                    <div class="flex-item" :class="{ 'fadeInLeft0': workflow_content_animation }">
                        <p>识别</p>
                        <img :src="require('@/assets/img/safe/t1.png')" alt="">
                        <p>标注目标监测设备，对接对应检测设备</p>
                    </div>
                    <div class="flex-item" :class="{ 'fadeInLeft2': workflow_content_animation }">
                        <p>修复</p>
                        <img :src="require('@/assets/img/safe/t3.png')" alt="">
                        <p>对泄漏点制定维修计划并实施</p>
                    </div>
                    <div class="flex-item" :class="{ 'fadeInLeft3': workflow_content_animation }">
                        <p>数据挖掘</p>
                        <img :src="require('@/assets/img/safe/t4.png')" alt="">
                        <p>对历史泄漏及修复情况进行分析总结，并反哺系统升级</p>
                    </div>
                    <div class="flex-item" :class="{ 'fadeInLeft4': workflow_content_animation }">
                        <p>实施</p>
                        <img :src="require('@/assets/img/safe/t5.png')" alt="">
                        <p>根据总结方案实施分级监测，不断循环迭代</p>
                    </div>
                </div>
            </div>

        </div>
        <div class="strip">
            <div class="commmon-padding content4">
                <div id="content4-title" style="width: 100%;">
                    <div v-show="value_title_animation" :class="{ 'title': true,'commit-tit':true, 'fadeInUp': value_title_animation }">
                        <h3>系统价值</h3>
                        <div class="small-text">Systemic Value</div>
                    </div>
                </div>

                <div class="" id="content4-content">
                    <div v-show="value_content_animation" :class="{ 'fadeInLeft': value_content_animation, 'left': true }">
                        <div style="background: #fff;  padding:20px;padding-bottom:0px ">
                            <el-carousel :interval="4000">
                                <el-carousel-item v-for="item in list" :key="item">
                                    <el-image style="width: 100%; height: auto" :src="item"></el-image>
                                </el-carousel-item>
                            </el-carousel>
                        </div>
                        <div v-if="value_content_animation" style="margin-top: 30px;">
                            <ul class="l_ul">
                                <li>
                                    <!-- <img :src="f1" alt=""> -->
                                    <NumScroll :endVal="20"></NumScroll>
                                    <p>巡检成本降低</p>
                                </li>
                                <li>
                                    <!-- <img :src="f2" alt=""> -->
                                    <NumScroll :endVal="30"></NumScroll>
                                    <p>巡检效率提升</p>
                                </li>
                                <li>
                                    <!-- <img :src="f3" alt=""> -->
                                    <NumScroll :endVal="30"></NumScroll>
                                    <p>巡检质量提升</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div v-show="value_content_animation"
                        :class="{ 'introduct': true, 'fadeInRight': value_content_animation, 'right': true }">
                        <p class="title">1.更规范</p>
                        <ul>
                            <li>1〉巡检动作精简，回收结果准确；</li>
                            <li>2〉巡检、保养计划精准、规律；</li>
                        </ul>
                        <p class="title">2.更便捷</p>
                        <ul>
                            <li>1〉移动端直接扫描二维码识别设备，快速提交报修单，故障响应快速，设备信息实时更新;</li>
                            <li>2〉维修人员可实时追踪维保进度;</li>
                        </ul>
                        <p class="title">3.更全面</p>
                        <ul>
                            <li>1〉维修保养工作统计等应用，帮助管理者快速了解整体维保情况;</li>
                            <li>2〉人员考核、角色分析与设备管理优化，均有据可依;</li>
                        </ul>
                        <p class="title">4.更效率</p>
                        <ul>
                            <li>1〉产品功能模块化，利于封装打包，部署实施高效落地;</li>
                            <li>2〉用数据提升运营管理，及时有效处理事故隐患，预测设备更换周期；</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import NumScroll from '../common/numscroll.vue'
export default {
    name: 'Safesystem',
    components: {
        NumScroll
        // import引入的组件需要注入到对象中才能使用
    },
    data() {
        return {
            fenxian2: require("@/assets/img/s1.png"),
            dui: require("@/assets/img/safe/dui.png"),
            f1: require("@/assets/img/safe/f1.png"),
            f2: require("@/assets/img/safe/f2.png"),
            f3: require("@/assets/img/safe/f3.png"),
            fenxian2_animation: false,
            content2_animation: false,
            content22_animation: false,
            activeName: '',
            workflow_title_animation: false,
            workflow_content_animation: false,
            value_title_animation: false,
            value_content_animation: false,
            list: [
                require("@/assets/img/safe/a1.png"),
                require("@/assets/img/safe/a2.png"),
                require("@/assets/img/safe/a3.png")
            ]
        }
    },
    created() {
        window.onscroll = false;
    },
    mounted() {
        this.$nextTick(() => {
            this.scroll();
            window.addEventListener('scroll', this.scroll)
        })
    },
    methods: {
        scroll() {
            const docScrollTop = document.documentElement.scrollTop - 175;
            const fenxian2_elOffsetTop = document.getElementById("fenxian2").offsetTop;
            if (fenxian2_elOffsetTop >= docScrollTop && fenxian2_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.fenxian2_animation = true;
            }
            const content2_elOffsetTop = document.getElementById("content2").offsetTop;
            const content22_elOffsetTop = document.getElementById("content22").offsetTop;
            if (content2_elOffsetTop >= docScrollTop && content2_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content2_animation = true;
            }
            if (content22_elOffsetTop >= docScrollTop && content22_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.content22_animation = true;
            }

            const content3_elOffsetTop = document.getElementById("content3-title").offsetTop;
            const content3_content_elOffsetTop = document.getElementById("content3-content").offsetTop;
            if (content3_elOffsetTop >= docScrollTop && content3_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.workflow_title_animation = true;
            }
            if (content3_content_elOffsetTop >= docScrollTop && content3_content_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.workflow_content_animation = true;
            }
            const content4_elOffsetTop = document.getElementById("content4-title").offsetTop;
            const content4_content_elOffsetTop = document.getElementById("content4-content").offsetTop;
            if (content4_elOffsetTop >= docScrollTop && content4_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.value_title_animation = true;
            }
            if (content4_content_elOffsetTop >= docScrollTop && content4_content_elOffsetTop < (docScrollTop + window.innerHeight)) {
                this.value_content_animation = true;
            }
        },
        mouseEnter(item) {
            console.log(item)
            this.activeName = item.target.dataset.name;
        }
        ,
        mouseOut() {
            this.activeName = ''
        }

    },
}
</script>

<style scoped lang="less">
.commmon-padding {
    align-items: center;
}

@keyframes an1 {
    0% {
        transform: rotateY(0deg);
    }

    50% {
        transform: rotateY(180deg);
        opacity: 0.5;
    }

    100% {
        transform: rotateY(360deg);
    }
}

@-webkit-keyframes an1

/* Safari 与 Chrome */
    {
    0% {
        transform: rotateY(0deg);
    }

    50% {
        transform: rotateY(180deg);
        opacity: 0.5;
    }

    100% {
        transform: rotateY(360deg);
    }
}

.fixd {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: space-Between;
    -webkit-justify-content: space-Between;
    -moz-box-pack: space-Between;
    -ms-flex-pack: space-Between;
    justify-content: space-Between;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.fadeInUp {
    animation: fadeInUp 1s;
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
}

.fadeInLeft {
    animation: fadeInLeft 1s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInDown {
    animation: fadeInDown 1s;
    -webkit-animation-name: fadeInDown;
    animation-name: fadeInDown;
}

.fadeInLeft0 {
    animation: fadeInLeft 1.2s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft1 {
    animation: fadeInLeft 1.4s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft2 {
    animation: fadeInLeft 1.6s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft3 {
    animation: fadeInLeft 1.8s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.fadeInLeft4 {
    animation: fadeInLeft 2s;
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
}

.title {
    width: 100%;
    text-align: center;
    margin-bottom: 40px;
}

.banner {
    background: url('~@/assets/img/safe/banner.png') no-repeat;
    background-size: 100% 100%;
}

.fenxian2,
.content4 {
    .introduct {
        width: 37%;

        .commit-tit {
            text-align: left;

            h3 {
                font-size: 30px;
                line-height: 1.4;
            }

            .small-text {
                font-size: 16px;
            }
        }

        .img-parent {
            width: 41%;
        }

        .text {
            font-size: 14px;
            line-height: 24px;
            color: #666;
            margin-top: 25px;
            text-align: justify;
        }
    }

    .img-parent {
        width: 41%;
    }

    .fadeInLeft {
        animation: fadeInLeft 1s;
        -webkit-animation-name: fadeInLeft;
        animation-name: fadeInLeft;
    }

    .fadeInRight {
        animation: fadeInRight 1s;
        -webkit-animation-name: fadeInRight;
        animation-name: fadeInRight;
    }
}

.content2 {
    ul {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        li {
            font-size: 14px;
            color: #666666;
            height: 160px;
            padding-top: 95px;
            width: 21%;
            border-radius: 8px;
            p {
                padding: 0 8px;
                line-height: 24px;
                margin-bottom: 15px;

                td:first-child{
                    color: #2895EA;
                    padding-right: 4px;
                    font-size: 25px;
                    vertical-align: text-top;
                    padding-top: 3px;
                }
            }

            &.active {
                animation: an1;
                animation-duration: 22s;
                animation-timing-function: ease;
                -webkit-animation: an1;
                -webkit-animation-duration: 2s;
                -webkit-animation-timing-function: ease;
            }
        }

        li:first-child {
            background: url('~@/assets/img/safe/1.png') no-repeat;
            background-size: 100% auto;
        }

        li:nth-child(2) {
            background: url('~@/assets/img/safe/2.png') no-repeat;
            background-size: 100% auto;
        }

        li:nth-child(3) {
            background: url('~@/assets/img/safe/3.png') no-repeat;
            background-size: 100% auto;
        }

        li:nth-child(4) {
            background: url('~@/assets/img/safe/4.png') no-repeat;
            background-size: 100% auto;
        }
    }

    .intr {
        margin-top: 20px;

        table {
            tr {
                td:last-child {
                    padding-left: 10px;
                }

            }
        }
    }
}

.content3 {

    .line {
        width: 100%;
        height: 23px;
        background: url('~@/assets/img/safe/s3.png') no-repeat;
        background-size: 100% auto;
        margin-top: 100px;
    }

    #content3-title {
        width: 100%;
        text-align: center;
    }

    #content3-content .content {
        width: 100%;
        .fixd();

        .flex-item {
            text-align: center;
            width: 20%;
            padding: 0 20px;

            p:first-child {
                margin-bottom: 20px
            }

            p:last-child {
                margin-top: 20px;
            }

            img:hover {
                scale: 1.2;
            }
        }

        flex-wrap: nowrap;
        margin-top: -142px;
        padding-bottom: 0;

    }
}

#content4-content {
    width: 100%;
    margin-bottom: 0px;
    .fixd();

    ul {
        margin-bottom: 10px;

        li {
            line-height: 26px;
        }
    }

    p.title {
        font-size: 24px;
        font-weight: bold;
        color: #2997EA;
        line-height: 33px;
        text-align: left;
        margin-bottom: 0;
    }

    .left {
        width: 42%;
    }

    .right {
        width: 53%;
    }
}

/deep/#content4-content {
    ul.l_ul {
        display: flex;
        justify-content: space-between;

        li {
            text-align: center;
            width: 30%;

            div {
                background: url('~@/assets/img/safe/f6.png') no-repeat;
                background-position-x: 10px;
            }

            &:nth-child(1) {
                div {
                    background: url('~@/assets/img/safe/f4.png') no-repeat;
                    background-position-x: 10px;
                }
            }

            .num {
                color: #fff;
                font-size: 20px;
                font-weight: normal;

                &::after {
                    content: '%';
                }
            }

            .statistics-num {
                height: 110px;
            }
        }
    }

    .el-carousel__button {
        background-color: #E7ECF3;
        opacity: 1;
    }

    .is-active {
        .el-carousel__button {
            background-color: #2997EA;
        }
    }
}
/deep/.el-carousel__container{
    height: 213px;
}

</style>



// WEBPACK FOOTER //
// src/components/page/safesystem.vue